import { Link } from 'react-router-dom'
import logo from '../../../assets/img/logo.svg'

export const AppLogo = () => {
  return (
    <div className="logo-topbar">
      <Link to="/app/overview" className="logo-light">
        <span className="logo-lg">
          <img src={logo} alt="Total Milk Hauler" width={32} height={32} />
        </span>
        <span className="logo-sm">
          <img src={logo} alt="Total Milk Hauler" width={24} height={24} />
        </span>
      </Link>
    </div>
  )
}
